import React, { useEffect, useState, useRef, useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import translate from './TranslateHOC';
import ListCardItemHolderMobile from '../v2/components/tvSchedule/ListCardItemHolderMobile';
import { ListCardItemHolderDesktop } from '../v2/components/tvSchedule/ListCardItemHolderDesktop';
import { useDebouncedCallback } from 'use-debounce';

const ListItemHolderV2 = ({ details, isToday }) => {
  const [isToggleProgramme, setIsToggleProgramme] = useState({});
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(false);
  const [currentTime, setCurrentTime] = useState(
    String(new Date().getHours()).padStart(2, '0') +
      ':' +
      String(new Date().getMinutes()).padStart(2, '0')
  );

  const handleProgrammeClick = (id) => {
    setIsToggleProgramme({
      ...isToggleProgramme,
      [id]: !isToggleProgramme[id],
    });
  };

  const handleKeyboardClick = (key, event) => {
    event.preventDefault();
    if (event.charCode === 32 || event.charCode === 13) {
      handleProgrammeClick(key);
    }
  };

  const updateDimensions = useDebouncedCallback(() => {
    setWidth(window.innerWidth);
  }, 200);

  const prevTimeRef = useRef('');

  useEffect(() => {
    const id = setInterval(() => {
      if (prevTimeRef.current !== currentTime) {
        setCurrentTime(currentTime);
        prevTimeRef.current = currentTime;
      }
    }, 1000);
    return () => clearInterval(id);
  }, [currentTime]);

  const debouncedUpdateDimensions = useCallback(() => {
    _.debounce(updateDimensions, 100)();
  }, [updateDimensions]);

  useEffect(() => {
    window.addEventListener('resize', debouncedUpdateDimensions);
    return () =>
      window.removeEventListener('resize', debouncedUpdateDimensions);
  }, [debouncedUpdateDimensions]);

  useEffect(() => {
    setIsMobile(width < 1140);
  }, [width]);

  if (!details) {
    return <div className="loadingContent">Loading...</div>;
  }

  const ignoreList = ['Cyw', 'Awr Fawr', 'Stwnsh'];

  return isMobile ? (
    <>
      {ignoreList.indexOf(details.title) === -1 && (
        <ListCardItemHolderMobile
          details={details}
          isToggleProgramme={isToggleProgramme}
          handleProgrammeClick={handleProgrammeClick}
          handleKeyboardClick={handleKeyboardClick}
        />
      )}

      {details.programmes?.map((programme) => (
        <ListCardItemHolderMobile
          key={programme.programme_id}
          details={programme}
          isToggleProgramme={isToggleProgramme}
          handleProgrammeClick={handleProgrammeClick}
          handleKeyboardClick={handleKeyboardClick}
        />
      ))}
    </>
  ) : (
    <>
      {ignoreList.indexOf(details.title) === -1 && (
        <ListCardItemHolderDesktop
          details={details}
          isMobile={isMobile}
          isChild={false}
          isToday={isToday}
        />
      )}
      {Object.entries(details.programmes).length > 0 &&
        Object.entries(details.programmes).map(([key, value]) => (
          <ListCardItemHolderDesktop
            key={key}
            details={value}
            isMobile={isMobile}
            isChild={!value.isContainer && ignoreList.includes(details.title)}
            parent={details.title}
            isToday={isToday}
          />
        ))}
    </>
  );
};

ListItemHolderV2.propTypes = {
  details: PropTypes.object.isRequired,
};

export default translate(connect(null)(ListItemHolderV2));
